import React, { Component, useState, Fragment } from "react";
import FireAssuranceContext from "./FireAssuranceContext";
import successful from "../../images/checked.svg";
import { CurrencyUtils } from "../../utils";
import { DATETHAI_FORMAT, DATETIME_PAYMENT_FORMAT } from "../../const";
import moment from "moment";
const imgScale = {
  width: "24px",
  height: "24px",
};
const Icon = (props) => <img className={props.className} src={props.src} {...imgScale} />;
class FireAssuranceStep5 extends Component {
  callBackAction;
  constructor(props) {
    super(props);
  }

  render() {
    const { step1, step2, step3, step4 } = this.context;
    // const { sStart_date, sEnd_date } = step2;
    const { selectedPlan, planList } = step1;
    const planDetail = planList[0];
    const { insured, total, name } = planDetail;
    const { onNavigate, refNo } = this.context.step5;
    // payment
    const { paymentModel } = this.context.step4;
    return (
      <div className="form-wrapper payment-wrapper successful">
        <div className="form-group d-flex flex-column flex-1 w-100">
          <Icon className="align-item-center w-100 payment-icon" src={successful} />
          <div className="form-group">
            <div className="successful-reactagle ">
              <label className="text-center">ชำระเบี้ยประกันเรียบร้อย</label>
              <p className="text-center">{moment().format(DATETIME_PAYMENT_FORMAT)}</p>
            </div>
          </div>
          <div className="form-wrapper successful-wrapper">
            {/* <div className="form-group"> */}
            <div className="form-group">
              <label className="total-value text-center">{CurrencyUtils.currency(total)} บาท</label>
            </div>
            <div className="form-group">
              <label className="ref-value text-center mt-0">Reference ID {refNo}</label>
            </div>
            <hr />
            <div className="form-wrapper">
              <div className="form-group">
                <label>เลขที่ใบสั่งซื้อ</label>
                <label className="order-value">{paymentModel.orderId}</label>
              </div>
              <div className="form-group">
                <label>ผลิตภัณฑ์</label>
                <label className="order-value">ประกันอัคคีภัยสำหรับบ้านอยู่อาศัย</label>
              </div>
              <div className="form-group">
                <label>แผนประกัน</label>
                <label className="order-value">แผน FR001</label>
              </div>
              <div className="form-group">
                <label>ทุนประกัน</label>
                <label className="order-value">{CurrencyUtils.currency(insured)} บาท</label>
              </div>
              {/* <div className="form-group">
                <label>วันที่เดินทาง</label>
                <label className="order-value">
                  {moment(sStart_date).format(DATETHAI_FORMAT)} -{" "}
                  {moment(sEnd_date).format(DATETHAI_FORMAT)}
                </label>
              </div> */}
            </div>
          </div>
          {/* </div> */}
          <div className="form-group successful-footer align-item-center">
            <label className="text-wrapper">
              คุณจะได้รับ {parseInt(total / 25)} AOT Point หลังจาก การซื้อประกันภายใน 15 วัน
            </label>
          </div>
          <div className="form-group footer">
            <button className="successful-btn align-item-center" onClick={() => (window.location.href = "/")}>
              ตกลง
            </button>
          </div>
        </div>
      </div>
    );
  }
}

FireAssuranceStep5.contextType = FireAssuranceContext;
export default FireAssuranceStep5;
